var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"etoile-score"},[(_vm.flamme)?_c('img',{staticClass:"flamme",attrs:{"src":"scores/flamme.png"}}):_vm._e(),_c('span',[_vm._t("default")],2),_c('img',{attrs:{"src":"scores/etoile.svg","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }